export default function AuthHoc(Hoc, isCpcGuestEligible) {
  return class AuthComponent extends React.Component {
    constructor(props) {
      super(props);
      this.isAuth = app.appService.isAuthenticated();
      this.isAuthorized = true; // true value replaced by fapservice
      this.isAuthorizedPath = app.appUtil.NavigationUtil.getUrlPathName();
      this.isGuestAuthenticated = app.appService.isGuest();
      this.isCpcGuestUser = app.appService.isCpcGuestUser();

      // A&N change to navigate user to login screen when user is trying to access non CPC modules when authenticated as CPC guest user.
      if ((!this.isAuth && !this.isGuestAuthenticated && !this.isCpcGuestUser) || (this.isCpcGuestUser && !isCpcGuestEligible)) {
        let urlParams = app.appUtil.getQueryParameters(window.location.href);
        if (urlParams && urlParams.userid) {
          app.appService.setSessionstorage('defaultUserId', urlParams.userid);
        }
        //Cpp Indicator 
        const cppStatus = app.appService.getSessionstorage('cppIndicator');
        if (cppStatus) {
          app.appService.setLocalStorage('isPortalUserAuthenticated', true);
        }

        // const oniIndicator = app.appService.getLocalStorage('oniIndicator');
        // if (oniIndicator) {
        //   app.pubSubService.publish("showOniLoginDialog");
        //   app.appService.deleteElementFromLocalStorage('oniIndicator');
        // }

        //app.appService.setLocalStorage('userpath', this.isAuthorizedPath);
        (this.isAuthorizedPath.indexOf(app.appUtil.getAppConstants().BNP_PATH) > -1 && this.isAuthorizedPath !== app.appUtil.getAppConstants().PAYMENT_ARRANGEMENT) ? app.appService.setLocalStorage(app.appUtil.getAppConstants().USERPATH, app.appUtil.getAppConstants().BNP_LANDING) : app.appService.setLocalStorage(app.appUtil.getAppConstants().USERPATH, this.isAuthorizedPath);
        return (app.appUtil.navigateTo(app.navigationService.getLoginRedirectionUrl()));
      }
    }
    render() {
        return (((this.isAuth || this.isGuestAuthenticated || this.isCpcGuestUser) && this.isAuthorized)?<Hoc />:null);
    }
  };
}
